export default "__VITE_ASSET__Btp_7Tvv__"